export const scenePlanEffectConstraints = [
    { effectKind: 'emphasis', targetFields: ['target'] },
    { effectKind: 'orbit', targetFields: ['target'], maximumPerSegment: 1, stationary: true, beforeCuesOnly: true },
];
